var map = {
	"./airbnbLogo.png": 101,
	"./codeInLogo.webp": 23,
	"./contactMail.webp": 102,
	"./contactMailDark.svg": 103,
	"./developerActivity.svg": 28,
	"./facebookLogo.png": 104,
	"./freelancer.jpg": 22,
	"./googleAssistant.svg": 105,
	"./googleAssistantLogo.webp": 24,
	"./harvardLogo.png": 106,
	"./jsFramework.svg": 107,
	"./logo2.png": 21,
	"./manOnTable.svg": 27,
	"./nextuLogo.webp": 108,
	"./programmer.svg": 109,
	"./pwa.webp": 110,
	"./pwaLogo.webp": 25,
	"./quoraLogo.png": 111,
	"./saayaHealthLogo.webp": 112,
	"./skill.svg": 29,
	"./stanfordLogo.png": 113,
	"./talksCardBack.svg": 114,
	"./talksCardBackAlt.svg": 115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;